import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route } from "react-router-dom";
import { applyMiddleware, createStore } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import decode from "jwt-decode";
import axios from "axios";
import "./index.css";
import App from "./App";
import rootReducer from "./rootReducer";
import { userLoggedIn } from "./actions/auth";
// import setAuthorizationHeader from "./utils/setAuthorizationHeader";
import registerServiceWorker from "./registerServiceWorker";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

try {
  if (localStorage.practitioner_token) {
    const payload = decode(localStorage.practitioner_token);
    const practitioner = {
      resp: {
        email_address: payload.email_address,
        practitioner_id: payload.practitioner_id,
        approved: payload.approved,
        fullname: payload.fullname,
        username: payload.username,
        names: payload.names,
        lastnames: payload.lastnames,
        role: payload.role,
        super_usuario:payload.super_usuario,
        entityUser: payload.entityUser,
        institucion: payload.institucion,
      },
      token: localStorage.practitioner_token,
    };
    axios.defaults.headers.common["Authorization"] = practitioner.token;
    store.dispatch(userLoggedIn(practitioner));
  }
} catch (error) {
  console.log(error);
}

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <GoogleReCaptchaProvider
          reCaptchaKey={process.env.REACT_APP_RECAPTCHA_APIKEY}
        >
          {console.log("Recaptcha key:", process.env.REACT_APP_RECAPTCHA_APIKEY)}
          <App/>
      </GoogleReCaptchaProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();
